{
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "电子邮箱",
    "login": "登录",
    "password": "密码",
    "recover_password": "恢复密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码"
  },
  "404": {
    "title": "此页面已去钓鱼",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "listPage": {
    "refresh": "刷新"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "dashboard": {
    "versions": "版本",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "city": "城市",
        "country": "国家",
        "infiniteConnections": "无限连接",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "brazilian_portuguese": "葡萄牙语",
    "english": "英语",
    "spanish": "西班牙语",
    "simplified_chinese": "简体中文",
    "persian": "波斯语"
  },
  "menu": {
    "auth": "授权",
    "buttons": "按钮",
    "timelines": "时间线",
    "dashboard": "仪表板",
    "users": "用户",
    "usersList": "用户列表",
    "usersAdmins": "管理员管理",
    "games": "游戏",
    "tags": "游戏标签",
    "posts": "帖子",
    "finance": "财务",
    "wallets": "钱包",
    "transactions": "交易",
    "tokens": "代币",
    "promotions": "推广",
    "auditEvents": "运营审计",
    "billing": "计费",
    "login": "登录",
    "signUp": "注册",
    "preferences": "偏好",
    "payments": "支付",
    "pricing-plans": "定价计划",
    "login-singup": "登录/注册",
    "404": "404 页面",
    "faq": "常见问题解答",
    "settings": "设置"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读"
  },
  "navbar": {
    "messageUs": "需要Web开发帮助吗？请联系我们。",
    "repository": "GitHub 仓库"
  },
  "notifications": {
    "all": "查看所有通知",
    "mark_as_read": "标为已读",
    "sentMessage": "{name} 给你发了一条消息",
    "uploadedZip": "{name} 上传了一个新的 Zip 文件 {type}",
    "startedTopic": "{name} 开始了一个新话题"
  },
  "user": {
    "language": "修改语言",
    "logout": "登出",
    "logout": "登出",
    "profile": "我的资料",
    "settings": "设置",
    "billing": "账单",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片",
      "stripeNoImage": "无图像条纹卡"
    },
    "button": {
      "main": "主要",
      "cancel": "取消"
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索..."
  },
  "users": {
    "title": "用户管理",
    "searchPlaceholder": "搜索昵称或邮箱",
    "empty": "暂无用户",
    "columns": {
      "nickname": "用户",
      "email": "邮箱",
      "role": "角色",
      "status": "状态",
      "mainToken": "主代币",
      "rewardToken": "奖励代币",
      "promoToken": "促销代币",
      "mainTokenShort": "主",
      "rewardTokenShort": "奖",
      "promoTokenShort": "促",
      "createdAt": "注册时间",
      "actions": "操作"
    },
    "role": {
      "admin": "管理员",
      "developer": "开发者",
      "player": "玩家"
    },
    "status": {
      "active": "正常",
      "inactive": "未激活",
      "banned": "已封禁"
    },
    "actions": {
      "edit": "编辑用户",
      "more": "更多操作",
      "sheetTitle": "用户操作",
      "sheetSection": "操作",
      "dangerZone": "危险操作",
      "deleteSelfDisabled": "不能删除当前登录账号",
      "changeStatus": "修改状态",
      "adjustTokens": "修改代币",
      "delete": "删除",
      "ban": "确认封禁",
      "refresh": "刷新"
    },
    "form": {
      "editTitle": "编辑用户",
      "nickname": "昵称",
      "email": "邮箱",
      "role": "角色",
      "status": "状态",
      "avatarReadonly": "头像仅展示，暂不支持编辑",
      "save": "保存"
    },
    "pagination": {
      "total": "共 {total} 条",
      "perPage": "每页"
    },
    "toast": {
      "updateSuccess": "用户 {nickname} 已更新",
      "deleteSuccess": "用户 {nickname} 已删除",
      "roleChangeWarning": "角色变更后，该用户需要重新登录才能生效"
    },
    "confirm": {
      "deleteTitle": "删除用户",
      "deleteMessage": "确定要删除用户「{nickname}」吗？此操作为软删除，用户将无法再登录。",
      "banTitle": "封禁用户",
      "banMessage": "确定要封禁用户「{nickname}」吗？封禁后用户将无法登录。",
      "unsavedChanges": "表单有未保存的更改，确定要关闭吗？"
    },
    "tokens": {
      "modalTitle": "修改代币",
      "reason": "调账原因",
      "reasonRequired": "请填写调账原因",
      "amountRequired": "请至少填写一种代币的非零变动值",
      "modeLabel": "调账模式",
      "mode": {
        "delta": "增量调账",
        "target": "目标余额"
      },
      "modeHint": "增量模式填变动值；目标模式填期望余额（仅改 balance，不动冻结）。",
      "currentBalances": "当前余额",
      "balance": "余额",
      "frozen": "冻结",
      "available": "可用",
      "loading": "加载中…",
      "submit": "提交调账单",
      "submitFailed": "调账失败",
      "success": "调账成功，单据 #{adjustmentId}",
      "disabled": "代币钱包未启用",
      "loadError": "加载代币失败"
    }
  },
  "usersAdmins": {
    "title": "管理员管理",
    "searchPlaceholder": "搜索昵称或邮箱",
    "tabs": {
      "admins": "当前管理员",
      "players": "提权玩家"
    },
    "actions": {
      "promote": "升为管理员",
      "demote": "降为玩家"
    },
    "confirm": {
      "promoteTitle": "提升权限",
      "promoteMessage": "确定将「{nickname}」设为管理员吗？",
      "demoteTitle": "降级权限",
      "demoteMessage": "确定将「{nickname}」降为玩家吗？角色变更后需重新登录生效。"
    },
    "toast": {
      "roleChanged": "用户 {nickname} 已调整为{role}"
    }
  },
  "tags": {
    "title": "游戏标签",
    "searchPlaceholder": "按 code 或名称搜索",
    "loading": "加载中…",
    "empty": "暂无标签",
    "columns": {
      "code": "Code",
      "type": "类型",
      "name": "名称"
    },
    "type": {
      "all": "全部类型",
      "genre": "类型",
      "category": "分类",
      "custom": "自定义"
    },
    "filters": {
      "type": "标签类型"
    },
    "actions": {
      "create": "新建标签",
      "edit": "编辑标签",
      "delete": "删除",
      "refresh": "刷新"
    },
    "yaml": {
      "export": "导出 YAML",
      "import": "导入 YAML",
      "template": "下载模板",
      "exportSuccess": "标签已导出为 YAML",
      "exportFailed": "导出失败",
      "templateSuccess": "模板已下载",
      "templateFailed": "模板下载失败",
      "parseFailed": "YAML 解析失败",
      "importTitle": "导入标签",
      "importHint": "按 code + tag_type 匹配：已存在则更新，不存在则新建。",
      "importSummary": "将导入 {count} 个标签",
      "confirmTitle": "确认导入",
      "importSuccess": "导入完成：新建 {created}，更新 {updated}",
      "importPartial": "部分完成：新建 {created}，更新 {updated}，失败 {failed}",
      "importFailed": "导入失败",
      "fileSelected": "已选择文件"
    },
    "form": {
      "createTitle": "新建标签",
      "editTitle": "编辑标签",
      "code": "Code",
      "codePlaceholder": "如 action",
      "type": "类型",
      "name": "名称",
      "namePlaceholder": "展示名称",
      "save": "保存"
    },
    "pagination": {
      "total": "共 {total} 条",
      "perPage": "每页"
    },
    "toast": {
      "createSuccess": "标签已创建",
      "updateSuccess": "标签已更新",
      "deleteSuccess": "已删除 {name}",
      "deleteInUse": "无法删除：仍有 {count} 个游戏关联此标签"
    },
    "confirm": {
      "deleteTitle": "删除标签",
      "deleteMessage": "确定删除 {name}？此操作不可撤销。"
    }
  },
  "games": {
    "title": "游戏管理",
    "searchPlaceholder": "按游戏标题搜索",
    "empty": "暂无游戏",
    "view": {
      "table": "表格视图",
      "card": "卡片视图"
    },
    "filters": {
      "status": "状态",
      "locale": "语言"
    },
    "columns": {
      "cover": "封面",
      "title": "标题",
      "status": "状态",
      "price": "价格",
      "platforms": "平台",
      "tags": "标签",
      "releaseDate": "发行日期"
    },
    "status": {
      "draft": "草稿",
      "review": "审核中",
      "published": "已发布",
      "rejected": "已驳回",
      "delisted": "已下架"
    },
    "price": {
      "free": "免费",
      "comingSoon": "即将推出"
    },
    "platform": {
      "windows": "Windows",
      "mac": "Mac",
      "linux": "Linux"
    },
    "pagination": {
      "total": "共 {total} 条",
      "perPage": "每页"
    },
    "actions": {
      "refresh": "刷新",
      "create": "新建游戏",
      "steamImport": "Steam 导入",
      "editTags": "编辑标签",
      "publish": "发布",
      "edit": "编辑",
      "cancel": "取消",
      "submit": "创建游戏"
    },
    "bulk": {
      "select": "选择",
      "selectAllDraft": "全选本页草稿",
      "selectedCount": "已选 {selected}/{total}",
      "publishSelected": "批量发布",
      "deleteSelected": "批量删除",
      "confirmTitle": "确认批量删除",
      "confirmMessage": "确认删除已选中的 {count} 个草稿游戏吗？此操作不可撤销。",
      "confirmPublishTitle": "确认批量发布",
      "confirmPublishMessage": "确认发布已选中的 {count} 个草稿游戏吗？",
      "toast": {
        "published": "已发布 {count} 个游戏",
        "publishFailed": "有 {count} 个游戏发布失败",
        "deleted": "已删除 {count} 个游戏",
        "failed": "有 {count} 个游戏删除失败"
      }
    },
    "editTags": {
      "title": "编辑游戏标签",
      "subtitle": "为游戏「{title}」调整标签关联。",
      "selectedCount": "已选择 {count} 个标签",
      "openPicker": "选择标签",
      "searchPlaceholder": "搜索标签名称或 code",
      "noResults": "暂无可显示标签",
      "save": "保存标签",
      "backToEdit": "返回编辑页",
      "toast": {
        "success": "标签已保存",
        "failed": "标签保存失败"
      }
    },
    "import": {
      "title": "Steam JSON 导入",
      "subtitle": "上传或粘贴 Steam appdetails JSON，先预览映射，再直接创建游戏草稿。",
      "locale": "导入语言",
      "upload": "上传 JSON 文件",
      "json": "JSON 内容",
      "placeholder": "粘贴 Steam appdetails JSON 到这里",
      "preview": "预览映射",
      "import": "导入为草稿",
      "reset": "清空",
      "emptyPreview": "请先上传或粘贴 Steam JSON，然后点击预览映射。",
      "fileSelected": "已选择文件：{name}",
      "note": "当前会导入主信息、翻译、公司和支持语言；截图、预告片和标签后续仍可在详情页补录。",
      "payload": "将提交的创建请求",
      "summary": {
        "title": "导入摘要",
        "subtitle": "确认预览结果是否符合预期。",
        "externalAppId": "Steam AppID",
        "translationLocale": "翻译语言",
        "companies": "公司数",
        "languages": "支持语言数",
        "screenshots": "截图数",
        "trailers": "预告片数",
        "tags": "标签数",
        "matchedTags": "匹配标签数",
        "unmatchedTags": "未匹配标签数"
      },
      "tags": {
        "title": "标签映射结果",
        "rule": "匹配规则：先按 code，再按名称。未匹配标签仅提示，不阻断导入。",
        "matched": "已匹配",
        "unmatched": "未匹配",
        "empty": "当前 JSON 中没有可映射的标签。"
      },
      "errors": {
        "previewFailed": "预览失败",
        "importFailed": "导入失败",
        "fileReadFailed": "读取文件失败",
        "tagsLoadFailed": "标签列表加载失败，已跳过自动匹配。"
      },
      "toast": {
        "success": "游戏草稿已创建"
      }
    },
    "detail": {
      "title": "游戏详情",
      "yes": "是",
      "no": "否",
      "tabs": {
        "overview": "概览",
        "content": "文案",
        "storeMedia": "商店媒体",
        "libraryMedia": "库媒体",
        "pricing": "定价",
        "technical": "技术",
        "audit": "审核"
      },
      "actions": {
        "viewDetail": "查看 {title} 详情",
        "viewFull": "查看完整详情",
        "close": "关闭",
        "backToList": "返回列表"
      },
      "meta": {
        "id": "ID #{id}",
        "locale": "语言：{locale}",
        "developerId": "开发者 ID"
      },
      "sections": {
        "developers": "开发商",
        "publishers": "发行商",
        "links": "相关链接"
      },
      "requirements": {
        "minimum": "最低配置",
        "recommended": "推荐配置"
      },
      "media": {
        "unnamedTrailer": "预告片",
        "openTrailer": "在新标签页打开预告片"
      },
      "audit": {
        "title": "审核操作",
        "history": "审核记录",
        "actionLabel": "操作",
        "reasonLabel": "原因",
        "reasonPlaceholder": "请输入审核意见或驳回原因",
        "reasonRequired": "驳回或要求修改时必须填写原因",
        "submit": "提交审核",
        "success": "审核已提交",
        "failed": "审核提交失败",
        "empty": "暂无审核记录",
        "actions": {
          "approve": "通过",
          "reject": "驳回",
          "request_changes": "要求修改"
        }
      },
      "library": {
        "save": "保存库媒体",
        "saveSuccess": "库媒体已保存",
        "saveFailed": "库媒体保存失败",
        "readOnlyHint": "当前状态仅可查看，草稿或已驳回时可编辑",
        "notUploaded": "未上传"
      }
    },
    "create": {
      "title": "新建游戏",
      "editTitle": "编辑游戏",
      "subtitle": "按步骤填写商店信息、素材与补充资料",
      "editSubtitle": "修改商店信息、素材与补充资料",
      "steps": {
        "content": "多语言文案",
        "pricing": "定价与平台",
        "images": "商店图片",
        "assets": "截图与预告片",
        "details": "补充信息",
        "review": "确认提交"
      },
      "sections": {
        "requirements": "配置要求",
        "screenshots": "游戏截图",
        "trailers": "预告片",
        "storeImages": "商店图片",
        "libraryAssets": "库媒体素材",
        "icons": "图标",
        "companies": "开发商 / 发行商",
        "supportedLanguages": "游戏内语言",
        "tags": "游戏标签",
        "summary": "创建摘要"
      },
      "fields": {
        "title": "游戏标题",
        "shortDescription": "简短描述",
        "aboutDescription": "关于这款游戏",
        "detailedDescription": "详细描述",
        "pcRequirementsMin": "Windows 最低配置",
        "pcRequirementsRec": "Windows 推荐配置",
        "macRequirementsMin": "Mac 最低配置",
        "macRequirementsRec": "Mac 推荐配置",
        "linuxRequirementsMin": "Linux 最低配置",
        "linuxRequirementsRec": "Linux 推荐配置",
        "isFree": "免费游戏",
        "currency": "货币",
        "basePriceCents": "现价（分）",
        "originalPriceCents": "原价（分）",
        "comingSoon": "即将推出",
        "releaseDate": "发行日期",
        "requiredAge": "年龄限制",
        "platformWindows": "Windows",
        "platformMac": "Mac",
        "platformLinux": "Linux",
        "headerImage": "Header 封面图",
        "mainCapsuleImage": "Main Capsule 图",
        "capsuleImage": "Small Capsule 图",
        "verticalCapsuleImage": "竖版 Capsule 图",
        "capsuleImageV5": "Capsule V5 图",
        "backgroundImage": "背景图",
        "backgroundRawImage": "背景原图",
        "libraryCapsuleImage": "库 Capsule 图",
        "libraryHeroImage": "库 Hero 图",
        "libraryLogoImage": "库 Logo 图",
        "libraryHeaderImage": "库 Header 图",
        "iconImage": "游戏图标",
        "appIconImage": "App 图标",
        "url": "URL",
        "thumbnailUrl": "缩略图 URL",
        "trailerTitle": "预告片标题",
        "isHighlight": "高亮预告片",
        "externalAppId": "外部 App ID",
        "externalSource": "外部来源",
        "website": "官网",
        "controllerSupport": "手柄支持",
        "supportUrl": "客服链接",
        "supportEmail": "客服邮箱",
        "metacriticScore": "Metacritic 分数",
        "metacriticUrl": "Metacritic 链接",
        "recommendationsTotal": "推荐数",
        "achievementsTotal": "成就总数",
        "companyName": "公司名称",
        "companyRole": "公司角色",
        "languageCode": "语言代码",
        "hasFullAudio": "完整配音",
        "tags": "标签"
      },
      "filters": {
        "tagType": "标签类型"
      },
      "tagType": {
        "all": "全部",
        "genre": "类型",
        "category": "分类",
        "custom": "自定义"
      },
      "placeholders": {
        "title": "请输入游戏标题",
        "description": "请输入内容",
        "url": "https://example.com/asset.jpg",
        "thumbnailUrl": "https://example.com/thumb.jpg",
        "website": "https://example.com",
        "email": "support [at] example.com"
      },
      "buttons": {
        "next": "下一步",
        "back": "上一步",
        "addScreenshot": "添加截图",
        "addTrailer": "添加预告片",
        "addCompany": "添加公司",
        "addLanguage": "添加语言",
        "remove": "删除",
        "upload": "上传文件",
        "uploadFromUrl": "从 URL 上传",
        "finish": "创建游戏",
        "save": "保存"
      },
      "messages": {
        "updated": "游戏已保存",
        "forbidden": "无权限编辑该游戏，或当前状态不可编辑",
        "loadFailed": "加载游戏详情失败"
      },
      "summary": {
        "draftStatus": "将以草稿状态创建",
        "screenshots": "截图",
        "trailers": "预告片",
        "platforms": "平台",
        "price": "价格"
      },
      "validation": {
        "primaryTitleRequired": "简体中文标题必填",
        "atLeastOnePlatform": "至少选择一个平台",
        "headerImageRequired": "Header 封面图必填",
        "capsuleImageRequired": "Small Capsule 图必填",
        "mainCapsuleImageRequired": "Main Capsule 图必填",
        "verticalCapsuleImageRequired": "竖版 Capsule 图必填",
        "libraryCapsuleImageRequired": "库 Capsule 图必填",
        "libraryHeroImageRequired": "库 Hero 图必填",
        "libraryLogoImageRequired": "库 Logo 图必填",
        "libraryHeaderImageRequired": "库 Header 图必填",
        "iconImageRequired": "游戏图标必填",
        "appIconImageRequired": "App 图标必填",
        "fiveScreenshotsRequired": "至少填写 5 张截图",
        "oneTrailerRequired": "至少填写 1 条预告片",
        "urlRequired": "URL 必填",
        "companyNameRequired": "公司名称必填",
        "supportedLanguageRequired": "语言代码必填"
      },
      "tooltips": {
        "title": "主语言 zh-CN 标题必填，点击翻译图标可补充其他 14 种语言。",
        "shortDescription": "商店列表和摘要展示使用的简短介绍，建议一句话说明卖点。",
        "aboutDescription": "商店正文的主介绍内容，可写玩法、特色与世界观。",
        "detailedDescription": "更完整的卖点与细节说明，适合长文案。",
        "requirements": "各平台配置要求支持多语言输入，未填写的语言不会提交。",
        "headerImage": "Header Capsule，推荐 920×430 PNG/JPG，用于商店顶部与推荐位。",
        "mainCapsuleImage": "Main Capsule，推荐 1232×706 PNG/JPG，用于首页轮播。",
        "capsuleImage": "Small Capsule，推荐 462×174 PNG/JPG，用于列表、搜索与榜单。",
        "verticalCapsuleImage": "竖版 Capsule，推荐 748×896 PNG/JPG，用于竖版推荐位。",
        "capsuleImageV5": "更紧凑的胶囊派生图，显示约 184×69，可选。",
        "backgroundImage": "商店背景图，推荐 1438×810 PNG/JPG，可选。",
        "backgroundRawImage": "背景原图，处理前素材，可选。",
        "libraryCapsuleImage": "库 Capsule，推荐 600×900 PNG/JPG，用于库网格封面。",
        "libraryHeroImage": "库 Hero，推荐 3840×1240 PNG/JPG，图片上不要放文字。",
        "libraryLogoImage": "库 Logo，透明 PNG，最大宽度 1280px。",
        "libraryHeaderImage": "库 Header，推荐 920×430 PNG/JPG，用于库列表页头图。",
        "iconImage": "游戏图标，推荐 256×256 PNG。",
        "appIconImage": "App 图标，推荐 184×184 PNG。",
        "screenshots": "至少 5 张 1920×1080、16:9 的实机 gameplay 截图。",
        "trailer": "至少 1 条预告片，推荐 1920×1080，H.264 + AAC。",
        "trailerTitle": "预告片标题同样支持多语言，会写入 asset translations。",
        "currency": "未填写时后端默认 USD。",
        "basePriceCents": "价格单位为分，例如 1999 表示 19.99。",
        "originalPriceCents": "原价单位为分，用于折扣前价格展示。",
        "platforms": "至少选择一个支持平台。",
        "releaseDate": "即将推出时可先填预计日期。",
        "requiredAge": "默认 0，表示无限制。",
        "externalSource": "可选 steam/native；未填时后端不会强制校验。",
        "controllerSupport": "支持 none / partial / full；未填默认 none。",
        "companies": "填写后每条必须包含公司名称和角色。",
        "supportedLanguages": "填写后每条必须包含语言代码，可勾选是否完整配音。"
      }
    }
  },
  "auditEvents": {
    "title": "运营审计",
    "empty": "暂无审计事件",
    "labels": {
      "anonymous": "匿名"
    },
    "hints": {
      "hotData": "默认仅展示近 90 天热数据；查询更早记录请选择起始日期并搜索。",
      "browseSampling": "浏览类事件为约 10% 采样，不代表完整访问记录。",
      "compact": "默认近 90 天 · 浏览类约 10% 采样"
    },
    "filters": {
      "category": "类别",
      "allCategories": "全部类别",
      "action": "动作",
      "actionPlaceholder": "动作，如 order.paid",
      "actionPlaceholderOrder": "动作，如 order.paid",
      "actionPlaceholderToken": "动作，如 token.freeze",
      "actorId": "操作者 UUID",
      "actorIdPlaceholder": "操作者 UUID",
      "targetType": "目标类型",
      "targetTypePlaceholder": "目标类型，如 order",
      "targetId": "目标 ID",
      "targetIdPlaceholder": "目标 ID",
      "fromDate": "起始日期",
      "toDate": "结束日期",
      "more": "更多筛选"
    },
    "columns": {
      "createdAt": "时间",
      "event": "事件",
      "actor": "操作者",
      "target": "目标",
      "change": "变更",
      "summary": "摘要"
    },
    "fields": {
      "id": "ID",
      "category": "类别",
      "action": "动作",
      "actorId": "操作者 ID",
      "actorRole": "操作者角色",
      "targetType": "目标类型",
      "targetId": "目标 ID",
      "prevValue": "变更前",
      "newValue": "变更后",
      "metadata": "元数据",
      "ipAddress": "IP 地址",
      "requestId": "请求 ID",
      "userAgent": "User-Agent",
      "createdAt": "创建时间"
    },
    "actions": {
      "search": "查询",
      "reset": "重置",
      "refresh": "刷新",
      "token_credit": "代币入账",
      "token_freeze": "代币冻结",
      "token_unfreeze_and_debit": "解冻并扣款",
      "order_paid": "订单支付",
      "order_refunded": "订单退款",
      "library_grant": "入库授权",
      "library_revoke": "撤销入库",
      "wallet_offset": "法币冲正",
      "admin_token_grant": "管理员发币",
      "admin_token_adjust": "人工调账",
      "admin_token_freeze": "风控冻结",
      "admin_order_refund": "管理员退款",
      "admin_user_role_change": "角色变更",
      "admin_user_status_change": "状态变更",
      "auth_signup": "用户注册",
      "auth_jwt_rejected": "JWT 拒绝",
      "sensitive_profile_update": "资料变更",
      "access_unauthorized": "未认证访问",
      "access_forbidden": "权限拒绝",
      "access_invalid_internal_key": "内部 Key 无效",
      "browse_game_search": "游戏搜索",
      "browse_game_detail": "游戏详情浏览"
    },
    "categories": {
      "wallet": "钱包",
      "token": "代币",
      "order": "订单",
      "library": "库",
      "auth": "认证",
      "sensitive": "敏感资料",
      "admin": "管理操作",
      "access": "访问控制",
      "browse": "浏览"
    },
    "drawer": {
      "title": "审计事件详情",
      "close": "关闭"
    },
    "pagination": {
      "total": "共 {total} 条",
      "perPage": "每页"
    }
  },
  "vuestic": {
    "search": "搜索",
    "noOptions": "未找到项目",
    "ok": "确认",
    "cancel": "取消",
    "uploadFile": "上传文件",
    "undo": "撤销",
    "dropzone": "将文件拖到此处上传",
    "fileDeleted": "文件已删除",
    "closeAlert": "关闭警告",
    "backToTop": "回到顶部",
    "toggleDropdown": "切换下拉菜单",
    "carousel": "轮播",
    "goPreviousSlide": "上一张幻灯片",
    "goNextSlide": "下一张幻灯片",
    "goSlide": "跳转到第 {index} 张幻灯片",
    "slideOf": "第 {index} 张，共 {length} 张",
    "close": "关闭",
    "openColorPicker": "打开颜色选择器",
    "colorSelection": "颜色选择",
    "colorName": "颜色 {color}",
    "decreaseCounter": "减少计数",
    "increaseCounter": "增加计数",
    "selectAllRows": "选择所有行",
    "sortColumnBy": "按 {name} 排序",
    "selectRowByIndex": "选择第 {index} 行",
    "resetDate": "重置日期",
    "nextPeriod": "下一个时间段",
    "switchView": "切换视图",
    "previousPeriod": "上一个时间段",
    "removeFile": "删除文件",
    "reset": "重置",
    "pagination": "分页",
    "goToTheFirstPage": "跳转到第一页",
    "goToPreviousPage": "跳转到上一页",
    "goToSpecificPage": "跳转到第 {page} 页",
    "goToSpecificPageInput": "输入页码以跳转",
    "goNextPage": "跳转到下一页",
    "goLastPage": "跳转到最后一页",
    "currentRating": "当前评分 {value} / {max}",
    "voteRating": "评分 {value} / {max}",
    "optionsFilter": "选项筛选",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分页向左移动",
    "movePaginationRight": "分页向右移动",
    "resetTime": "重置时间",
    "closeToast": "关闭提示",
    "selectedOption": "已选选项",
    "noSelectedOption": "未选择选项",
    "breadcrumbs": "面包屑导航",
    "counterValue": "计数值",
    "selectedDate": "选择的日期",
    "selectedTime": "选择的时间",
    "progressState": "进度状态",
    "color": "颜色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步骤",
    "progress": "进度",
    "loading": "加载中",
    "sliderValue": "当前滑块值为 {value}",
    "switch": "切换",
    "inputField": "输入框",
    "fileTypeIncorrect": "文件类型不正确",
    "select": "选择一个选项"
  }
}
